<template>
        <div id="limit-error-modal">
            <div class="header clearfix">
                <div class="float-right cross " style="cursor:pointer" @click="close()">

                </div>
            </div>
            <div class="body">
                <h2 class="text-center " style="color: red">{{$t('errors.limit')}} </h2>
                <div class="actions">
<!--                    <button class="btn btn-primary" @click="tryAgain()">Попробовать снова</button>-->
                </div>

            </div>
        </div>
</template>

<script>
    export default {
        name: "LimitErrorModal",
        mounted() {
           // setTimeout(() => window.location.reload(),4000)
        }
    }
</script>

<style scoped>
    #limit-error-modal {
        z-index: 9999;
        position: absolute;
        width: 500px;
        left: calc(50% - 250px);
        height: 200px;
        top: 25%;
        padding: 10px 25px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(10, 71, 102, 0.05);
        border-radius: 4px;
    }

    #limit-error-modal .cancel-btn {
        width: 100%;
        border-radius: 5px;
        background-color: transparent;
        font-size: 18px;
        font-family: "ProximaNovaBold", sans-serif;
        color: #0a4766;
        margin-bottom: 20px;
        transition: .2s ease background-color;
        border: 1.5px solid #03A9F4;
        line-height: 1.5;
        vertical-align: middle;
    }
    #limit-error-modal .cross{
        margin: 10px;
    }
    #limit-error-modal .body .actions{
        width: 70%;
        margin: 0 auto;
    }
</style>
